import { configClient } from 'components/provider/ConfigProvider'
import Ajax from 'utils/request/ajax'

export const BUILDING_UPLOAD_TYPE = {
	BUILDING: 'building',
	FLOOR: 'floor',
	ROOM: 'room'
}

const HelperManagementBuilding = {
	uploadImage: ( base64, type, guid, { onStart = null, onSuccess = null, onError = null } = {} ) => {
		Ajax.request( configClient.url() + '/connection/rest/building/upload_image', {
			variables: {
				non_encoded_image: base64,
				type: type,
				guid: guid
			},
			onSuccess: ( result ) => {
				if( onSuccess !== null ) {
					onSuccess( result );
				}
			},
			onError: ( result ) => {
				if( onError !== null ) {
					onError( result );
				}
			},
			onStart: () => {
				if( onStart !== null ) {
					onStart();
				}
			}
		});
	}
}

export default HelperManagementBuilding
